import { AxiosInstance } from "axios";
import { createRepository } from "@/repositories/BaseRepository";

declare global {
    interface Window {
        keycloak: any;
        tenantActive: any;
    }
}

export class RepositoryProvider implements ProvideConfig {
    baseUrl: string;
    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    provideService(): AxiosInstance {
        const instance = createRepository(this.baseUrl,
                instanceOf => {
                    instanceOf.interceptors.request.use(request => {
                        request.headers["X-TenantId"] = localStorage.tenantId;
                        request.headers.common["Access-Control-Allow-Origin"] = "*";
                        return request;
                    });
                }
            )

        return instance;
    }
}

interface ProvideConfig {
    provideService(): AxiosInstance;
}
